import styled from 'styled-components';

export const ForwardContainer = styled.div`
  border-left: 3px solid #5e72e4;
  background: #f1f4fb;
  padding: 8px 12px;
  margin-bottom: 12px;
  border-radius: 6px;
  font-size: 13px;
  color: #4a4a4a;
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;

  div {
    display: flex;
    gap: 3px;
  }
`;

export const ForwardHeader = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
  font-size: 0.85rem;
  color: #5e72e4;
`;

export const ForwardMeta = styled.div`
  font-size: 0.75rem;
  color: #7d7d7d;
  margin-bottom: 6px;

  span {
    font-weight: bold;
  }
`;

export const ForwardContent = styled.div`
  font-size: 0.85rem;
  color: #333;
  max-height: ${({ expanded }) => (expanded ? '31.25rem' : '4.5em')};
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease;
  cursor: pointer;

  p {
    margin: 0;
  }

  &:hover {
    background-color: rgba(94, 114, 228, 0.05);
  }
`;

export const ToggleExpand = styled.button`
  background: none;
  border: none;
  color: #5e72e4;
  cursor: pointer;
  font-size: 0.75rem;
  padding: 4px 0;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }
`;

export const ForwardAttachments = styled.div`
  margin-top: 6px;
  font-size: 0.75rem;
  color: #5e72e4;
`;

export const ScrollButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #5e72e4;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: transform 0.2s ease, color 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
    color: #2c4ae2;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #f5365c;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;

  &:hover {
    background-color: #fee6e9;
  }
`;
